import { ExpandableRow } from 'components/table/ExpandableRow';
import { Totals } from 'models/data';

export interface ArticleVisibilityMeasureCell {
  value: number;
  rate: number;
  flags?: string[];
}

export type ArticleVisibilityMeasureKey =
  | 'actArtNumCD'
  | 'inaArtNumCD'
  | 'expArtNumCD'
  | 'nexArtNumCD'
  | 'asrOnlArtNumCD'
  | 'asrNonArtNumCD'
  | 'slgArtNumCD'
  | 'nslArtNumCD';

export interface ArticleVisibilityRow extends ExpandableRow<ArticleVisibilityRow> {
  id: string;
  name: string;
  actArtNumCD: ArticleVisibilityMeasureCell;
  inaArtNumCD: ArticleVisibilityMeasureCell;
  expArtNumCD: ArticleVisibilityMeasureCell;
  nexArtNumCD: ArticleVisibilityMeasureCell;
  asrOnlArtNumCD: ArticleVisibilityMeasureCell;
  asrNonArtNumCD: ArticleVisibilityMeasureCell;
  slgArtNumCD: ArticleVisibilityMeasureCell;
  nslArtNumCD: ArticleVisibilityMeasureCell;
}

export const NONE_ONLINE_FLAG = 'NoneOnline';

export const TABLE_MEASURE_KEYS: ArticleVisibilityMeasureKey[] = [
  'actArtNumCD',
  'inaArtNumCD',
  'expArtNumCD',
  'nexArtNumCD',
  'asrOnlArtNumCD',
  'asrNonArtNumCD',
  'slgArtNumCD',
  'nslArtNumCD',
];

export interface MetricsCardContent {
  stepperId: string;
  cardId: string;
  column: string;
  label: string;
  value?: number;
  percentage?: number;
  interpretation?: number;
  exportMetric?: string;
}

export function buildMetricsSteps(totals: Totals): MetricsCardContent[] {
  const v = totals.values;
  return [
    {
      stepperId: 'articleVisibility.stepOne',
      cardId: 'articleVisibility.stepOne.title',
      label: 'Created articles',
      column: 'created',
      value: v.creArtNumCD ?? 0,
    },
    {
      stepperId: 'articleVisibility.stepTwo',
      cardId: 'articleVisibility.stepTwo.titleOne',
      label: 'Channel activated articles',
      column: 'activated',
      value: v.actArtNumCD ?? 0,
      percentage: v.actArtRateCD,
      interpretation: 1,
      exportMetric: 'activated',
    },
    {
      stepperId: 'articleVisibility.stepTwo',
      cardId: 'articleVisibility.stepTwo.titleTwo',
      label: 'Channel not activated articles',
      column: 'activated',
      value: v.inaArtNumCD ?? 0,
      percentage: v.inaArtRateCD,
      interpretation: -1,
      exportMetric: 'not_activated',
    },
    {
      stepperId: 'articleVisibility.stepThree',
      cardId: 'articleVisibility.stepThree.titleOne',
      label: 'Exported articles',
      column: 'exported',
      value: v.expArtNumCD ?? 0,
      percentage: v.expArtRateCD,
      interpretation: 1,
      exportMetric: 'exported',
    },
    {
      stepperId: 'articleVisibility.stepThree',
      cardId: 'articleVisibility.stepThree.titleTwo',
      label: 'Not exported articles',
      column: 'exported',
      value: v.nexArtNumCD ?? 0,
      percentage: v.nexArtRateCD,
      interpretation: -1,
      exportMetric: 'not_exported',
    },
    {
      stepperId: 'articleVisibility.stepThree',
      cardId: 'articleVisibility.measure.artAwiNum.name',
      label: 'Awaiting internal status',
      column: 'exported',
      value: v.awiArtNumCD ?? 0,
      percentage: v.awiArtRateCD,
      interpretation: -1,
      exportMetric: 'awaiting_internal_status',
    },
    {
      stepperId: 'articleVisibility.stepFour',
      cardId: 'articleVisibility.stepFour.titleOne',
      label: 'Online articles',
      column: 'online',
      value: v.asrOnlArtNumCD ?? 0,
      percentage: v.asrOnlArtRateCD,
      interpretation: 1,
      exportMetric: 'online',
    },
    {
      stepperId: 'articleVisibility.stepFour',
      cardId: 'articleVisibility.stepFour.titleTwo',
      label: 'Offline articles',
      column: 'online',
      value: v.asrNonArtNumCD ?? 0,
      percentage: v.asrNonArtRateCD,
      interpretation: -1,
      exportMetric: 'not_online',
    },
    {
      stepperId: 'articleVisibility.stepFour',
      cardId: 'articleVisibility.measure.artAwmNum.name',
      label: 'Awaiting marketplace status',
      column: 'online',
      value: v.awmArtNumCD ?? 0,
      percentage: v.awmArtRateCD,
      interpretation: -1,
      exportMetric: 'awaiting_marketplace_status',
    },
    {
      stepperId: 'articleVisibility.stepFive',
      cardId: 'articleVisibility.stepFive.titleOne',
      label: 'Selling articles',
      column: 'selling',
      value: v.slgArtNumCD ?? 0,
      percentage: v.slgArtRateCD,
      interpretation: 1,
      exportMetric: 'selling',
    },
    {
      stepperId: 'articleVisibility.stepFive',
      cardId: 'articleVisibility.stepFive.titleTwo',
      label: 'Not selling articles',
      column: 'selling',
      value: v.nslArtNumCD ?? 0,
      percentage: v.nslArtRateCD,
      interpretation: -1,
      exportMetric: 'not_selling',
    },
  ];
}
